/**
 * Workspace Domain Types
 *
 * Workspaces allow users to organize their financial data into separate contexts:
 * - Personal finances
 * - Business/Auto-entrepreneur
 * - Associations
 *
 * Each workspace has its own accounts, categories, counterparties, etc.
 * Users can be members of multiple workspaces with different roles.
 */
/**
 * Workspace labels for UI display
 */
export const WORKSPACE_TYPE_LABELS = {
    personal: { fr: 'Personnel', en: 'Personal' },
    business: { fr: 'Professionnel', en: 'Business' },
    association: { fr: 'Association', en: 'Association' },
    other: { fr: 'Autre', en: 'Other' },
};
/**
 * Role labels for UI display
 */
export const WORKSPACE_ROLE_LABELS = {
    owner: { fr: 'Propriétaire', en: 'Owner' },
    admin: { fr: 'Administrateur', en: 'Admin' },
    member: { fr: 'Membre', en: 'Member' },
    viewer: { fr: 'Lecteur', en: 'Viewer' },
};
/**
 * Role permissions
 */
export const WORKSPACE_ROLE_PERMISSIONS = {
    owner: {
        canEdit: true,
        canDelete: true,
        canInvite: true,
        canManageMembers: true,
        canManageSettings: true,
    },
    admin: {
        canEdit: true,
        canDelete: false,
        canInvite: true,
        canManageMembers: true,
        canManageSettings: true,
    },
    member: {
        canEdit: true,
        canDelete: false,
        canInvite: false,
        canManageMembers: false,
        canManageSettings: false,
    },
    viewer: {
        canEdit: false,
        canDelete: false,
        canInvite: false,
        canManageMembers: false,
        canManageSettings: false,
    },
};
//# sourceMappingURL=workspace.js.map